<template>
  <div class="hs-empty-state">
    <div class="hs-empty-state__card">
      <div class="hs-empty-state__icon">
        <vue-feather
          :type="icon"
          :size="iconSize"
          :class="iconColor"
        />
      </div>
      <h3
        :class="[
          'hs-empty-state__title',
          titleSize === 'lg' ? 'text-lg' : 'text-base',
          titleColor,
        ]"
      >
        {{ title }}
      </h3>
      <p :class="['hs-empty-state__description', descriptionColor]">
        {{ description }}
      </p>
      <div v-if="showAction" class="mt-5">
        <slot name="action">
          <button
            v-if="actionText"
            @click="$emit('action')"
            :class="[
              'px-4 py-2 rounded-lg font-medium transition-colors duration-200',
              actionButtonClass,
            ]"
          >
            {{ actionText }}
          </button>
        </slot>
      </div>
      <div v-if="showSuggestion" class="mt-3">
        <p class="hs-empty-state__suggestion">
          {{ suggestion }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: String,
      default: "bar-chart-2",
    },
    iconSize: {
      type: [String, Number],
      default: 48,
    },
    iconColor: {
      type: String,
      default: "text-gray-400 dark:text-gray-600",
    },
    title: {
      type: String,
      default: "No Data Available",
    },
    titleSize: {
      type: String,
      default: "lg", // "lg" or "base"
      validator: (value) => ["lg", "base"].includes(value),
    },
    titleColor: {
      type: String,
      default: "text-gray-900 dark:text-gray-100",
    },
    description: {
      type: String,
      default: "There is no data available for the selected period.",
    },
    descriptionColor: {
      type: String,
      default: "text-gray-500 dark:text-gray-400",
    },
    showAction: {
      type: Boolean,
      default: false,
    },
    actionText: {
      type: String,
      default: "",
    },
    actionButtonClass: {
      type: String,
      default:
        "bg-blue-600 hover:bg-blue-700 text-white dark:bg-blue-500 dark:hover:bg-blue-600",
    },
    showSuggestion: {
      type: Boolean,
      default: false,
    },
    suggestion: {
      type: String,
      default: "",
    },
  },
  emits: ["action"],
};
</script>

<style scoped>
.hs-empty-state {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 2.6rem 1rem;
}

.hs-empty-state__card {
  background:
    radial-gradient(circle at 50% 0%, color-mix(in srgb, var(--hs-primary, #3293ec) 10%, transparent), transparent 34%),
    color-mix(in srgb, var(--hs-surface, #ffffff) 86%, transparent);
  border: 1px solid var(--hs-border, rgba(148, 163, 184, 0.22));
  border-radius: 24px;
  box-shadow: 0 18px 46px rgba(15, 23, 42, 0.07);
  max-width: 32rem;
  padding: 2rem;
  position: relative;
  text-align: center;
  width: min(100%, 32rem);
}

.hs-empty-state__icon {
  align-items: center;
  background: color-mix(in srgb, var(--hs-primary, #3293ec) 10%, transparent);
  border: 1px solid color-mix(in srgb, var(--hs-primary, #3293ec) 18%, transparent);
  border-radius: 20px;
  color: var(--hs-primary, #3293ec);
  display: inline-flex;
  height: 4.4rem;
  justify-content: center;
  margin-bottom: 1rem;
  width: 4.4rem;
}

.hs-empty-state__title {
  font-weight: 950;
  margin-bottom: 0.45rem;
}

.hs-empty-state__description {
  font-weight: 700;
  line-height: 1.65;
  margin: 0 auto;
  max-width: 25rem;
}

.hs-empty-state__suggestion {
  color: var(--hs-muted, #64748b);
  font-size: 0.76rem;
  font-weight: 800;
}
</style>
